import { FunctionComponent, ReactNode, useState, useCallback } from 'react'
import { SerializedStyles } from '@emotion/react'

import { useStyles } from './useStyles'

interface CollapsibleProps {
  children: ReactNode
  startIcon?: ReactNode
  title: string
  openedIcon?: ReactNode
  closedIcon?: ReactNode
  sx?: {
    container?: SerializedStyles
    togglerWrapper?: SerializedStyles
    togglerTitle?: SerializedStyles
    contentWrapper?: SerializedStyles
  }
}

const Collapsible: FunctionComponent<CollapsibleProps> = ({
  children,
  startIcon,
  title,
  openedIcon,
  closedIcon,
  sx,
}) => {
  const [isOpened, setIsOpened] = useState<boolean>(false)
  const { container, togglerWrapper, togglerTitle, contentWrapper } = useStyles(
    { isOpened },
  )

  const toggleCollapsible = useCallback(() => {
    setIsOpened(!isOpened)
  }, [isOpened])

  const togglerModifier = isOpened ? 'opened' : 'closed'

  return (
    <div
      css={[container, sx?.container]}
      className={`hero-collapsible hero-collapsible--${togglerModifier}`}
    >
      <button
        css={[togglerWrapper, sx?.contentWrapper]}
        className={`hero-collapsible__toggler hero-collapsible__toggler--${togglerModifier}`}
        onClick={toggleCollapsible}
      >
        <div
          css={[togglerTitle, sx?.togglerTitle]}
          className="hero-collapsible__label-container"
        >
          {startIcon && (
            <span className="hero-collapsible__start-icon">{startIcon}</span>
          )}
          <p className="hero-collapsible__label">{title}</p>
        </div>

        {isOpened ? (
          <span className="hero-collapsible__opened-icon">{openedIcon}</span>
        ) : (
          <span className="hero-collapsible__closed-icon">{closedIcon}</span>
        )}
      </button>

      <div
        css={[contentWrapper, sx?.contentWrapper]}
        className={`hero-collapsible__content hero-collapsible__content--${togglerModifier}`}
      >
        {children}
      </div>
    </div>
  )
}

export { Collapsible }
